import { render, staticRenderFns } from "./changePromotionModal.vue?vue&type=template&id=05f44788&scoped=true&lang=html&"
import script from "./changePromotionModal.vue?vue&type=script&lang=js&"
export * from "./changePromotionModal.vue?vue&type=script&lang=js&"
import style0 from "./changePromotionModal.vue?vue&type=style&index=0&id=05f44788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f44788",
  null
  
)

export default component.exports